import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import {Box, LinearProgress, Tooltip} from "@mui/material";
import {useState} from "react";

async function removeUserEmail(allowed_email_id) {
    return fetch(`${process.env.REACT_APP_SERVER_URL}/allowed_emails`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({allowed_email_id})
    }).then(data => data.json())
}

export default function SuperAdminDeleteAlertDialog({userToRemove, allowedEmails, setAllowedEmails, rerender}) {
    const [open, setOpen] = useState(false);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = () => {
        setSaving(true);
        removeUserEmail(userToRemove.allowed_email_id).then(result => {
            if(result?.state) {
                let indexToDelete = allowedEmails.findIndex(user => user.allowed_email_id === userToRemove.allowed_email_id);
                let newArray = [...allowedEmails];
                newArray.splice(indexToDelete, 1);
                setAllowedEmails(newArray);
                setOpen(false);
                setSaving(false);
                rerender(true);
            } else {
                setError(result?.error ? result.error : 'Error on removing user.');
                setSaving(false);
            }
        })
    };

    return (
        <Box sx={{display:'flex', alignItems:'center', justifyContent:'end'}} pr={1}>
            <Tooltip title={`Delete ${userToRemove.email}`}>
                <RemoveCircleOutlineIcon sx={{fontSize:16}} cursor={'pointer'} color={'error'} onClick={handleClickOpen}/>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                { saving && <LinearProgress/> }
                <DialogTitle id="alert-dialog-title">
                    Delete Email
                </DialogTitle>
                <DialogContent>
                    <DialogContentText color={'error'}>{error}</DialogContentText>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete <b>{userToRemove.email}</b>?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} disabled={saving}>Cancel</Button>
                    <Button onClick={handleDelete} autoFocus disabled={saving}>DELETE</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
